import styled from '@emotion/styled';
import css from '@emotion/css';
import Collapse from 'react-bootstrap/Collapse';
import { shadowLight } from 'app/colors';
import ButtonWithDropdown from 'components/Button/WithDropdown';
import { CONTENT_MAX_WIDTH } from 'components/Layout/PageContentWidth';
import { SIDEBAR_GAP, SIDEBAR_WIDTH } from './AutomationFolders/constants';
import { StyledFolder } from 'components/Kizen/Table/CellLineHeightStyles';
import {
  SortableHeadCell,
  TextEllipsisWithTooltip,
} from '__components/Kizen/Table';
import { TABLE_HEADER_HEIGHT } from 'components/Tables/Basic';
import TextInput from 'components/Inputs/TextInput';
import Dropdown from 'components/Fields/FieldInput/Dropdown';
import { BigListTitle } from 'components/Layout/BigListLayout';
import { BigListToolbar } from 'components/Layout/BigListLayout/Toolbar';
import { fontSizes, KizenTypography } from '__app/typography';
import TableActionCell from 'components/Tables/ActionCell';

export const StyledWrapperStatus = styled.p`
  font-size: ${fontSizes.text};
  margin-bottom: 0;
`;

export const StyledBigListToolbar = styled(BigListToolbar)`
  padding-top: 2px;
  height: 51px;
`;

export const StyledBigListTitle = styled(BigListTitle)`
  margin-top: 17px;
  margin-bottom: 14px;
`;

export const StyledModalTextInput = styled(TextInput)`
  margin-bottom: 17px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledModalSelect = styled(Dropdown)`
  margin-bottom: 17px;
`;

export const StyledNoActionsCell = styled.div`
  width: 14px;
  height: 20px;
`;

export const StyledActionCell = styled(TableActionCell)<{
  isHovered: boolean;
}>`
  position: sticky;
  right: 0;
  z-index: 2;
  ${({ isHovered }) =>
    isHovered
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
        `}
`;

export const StyledAutomationFolder = styled(StyledFolder)`
  width: fit-content;
  max-width: 100%;
  cursor: pointer;
`;

export const StyledFolderLink = styled(TextEllipsisWithTooltip)`
  margin-left: 8px;
`;

export const StyledCounts = styled(KizenTypography)`
  flex-shrink: 0;
  color: var(--color-button-secondary-default);
  margin-left: 4px;
`;

export const StyledButtonWithDropdown = styled(ButtonWithDropdown)`
  button:first-child {
    max-width: 190px;
    overflow: hidden;
  }

  .ButtonMenu__menu {
    max-width: max-content;
  }
`;

export const StyledCollapse = styled(Collapse)`
  ${shadowLight}
`;

export const StyledBigTableWrapper = styled.div`
  max-width: calc(${CONTENT_MAX_WIDTH} - ${SIDEBAR_WIDTH + SIDEBAR_GAP}px);
  width: calc(100% - ${SIDEBAR_WIDTH + SIDEBAR_GAP}px);
  align-self: flex-start;
  margin-bottom: 50px;
`;

export const StyledMobileActionCellWrapper = styled.div`
  i {
    width: 15px;
    svg {
      width: 15px;
      height: auto;
    }
  }
`;

export const StyledSortableHeadCell = styled(SortableHeadCell)`
  ${({ resizing }) => css`
    height: 100%;
    position: relative;
    cursor: ${resizing ? 'ew-resize' : 'auto'};
    & > * {
      pointer-events: ${resizing ? 'none' : 'auto'};
    }
    & > div {
      height: 100%;
      display: flex;
      align-items: center;
    }
    &.Resizing svg line {
      stroke: var(--color-background-darker);
    }
  `}

  height: ${TABLE_HEADER_HEIGHT}px; // for safari
`;
